import React from "react";
import OnboardingModal from "./OnboardingModal";
import { useI18n } from "../i18n";
import "./Auth.css";
import "./OnboardingModal.css";

function RegistrationForm() {
  const { t } = useI18n();
  return (
    <div className="auth-page onboarding-page">
      <div className="auth-shell onboarding-background-shell" aria-hidden="true">
        <div className="auth-info-panel onboarding-background-panel">
          <div className="auth-brand">
            <span className="auth-brand-icon">♥</span>
            <span>TajneMysli</span>
          </div>

          <h1>{t("registration.createAccount")}</h1>

          <p>
            {t("registration.description")}
          </p>

          <div className="auth-feature-list">
            <div className="auth-feature">
              <span>1</span>
              <p>{t("registration.profileStep")}</p>
            </div>

            <div className="auth-feature">
              <span>2</span>
              <p>{t("registration.browseStep")}</p>
            </div>

            <div className="auth-feature">
              <span>3</span>
              <p>{t("registration.matchStep")}</p>
            </div>
          </div>
        </div>

        <div className="auth-card onboarding-background-card">
          <div className="auth-card-header">
            <h2>{t("registration.register")}</h2>
            <p>
              {t("registration.rulesDescription")}
            </p>
          </div>

          <div className="onboarding-background-preview">
            <div />
            <div />
            <div />
          </div>
        </div>
      </div>

      <div className="onboarding-overlay">
        <OnboardingModal />
      </div>
    </div>
  );
}

export default RegistrationForm;
